import { QueryBuilderAstNodeType, SavedQueryType } from '../../types';
import { areAstsEqual } from './helpers';

export const findActiveFavorite = (
  savedQueries: SavedQueryType[],
  ast: QueryBuilderAstNodeType | null
): SavedQueryType | undefined => {
  if (!ast) return undefined;

  return savedQueries.find((savedQuery) => areAstsEqual(savedQuery.ast, ast));
};
